import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem, SelectSeparator } from "@/components/ui/select";

// Výběr kategorie z firemního číselníku — všude stejný (§B). Placeholder, když
// hodnota v číselníku není (např. smazaná). „+ Spravovat kategorie…" jen pro kurátory.
export function CategorySelect({ value, onChange, cats, canVzornik, onManage, className, testid, placeholder = "Kategorie" }) {
  const known = cats.some((c) => c.name === value);
  return (
    <Select value={known ? value : undefined} onValueChange={(v) => (v === "__manage" ? onManage?.() : onChange(v))}>
      <SelectTrigger className={className} data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent className="max-h-[300px]">
        {cats.length === 0 && <div className="px-3 py-2 text-[13px] text-muted-foreground">Zatím žádné kategorie</div>}
        {cats.map((c) => <SelectItem key={c.id || c.name} value={c.name} data-testid={`cat-opt-${c.name}`}>{c.name}</SelectItem>)}
        {canVzornik && onManage && (
          <>
            <SelectSeparator />
            <SelectItem value="__manage" className="font-semibold text-brand" data-testid="cat-opt-manage">+ Spravovat kategorie…</SelectItem>
          </>
        )}
      </SelectContent>
    </Select>
  );
}
